import { OPEN_REORDER_CONFIRMATION_MODAL, CLOSE_REORDER_CONFIRMATION_MODAL } from 'actions/actionTypes';

export const openReorderConfirmationModalAction = ({ onClose, onSelect, currentState }) => ({
  type: OPEN_REORDER_CONFIRMATION_MODAL,
  payload: {
    onClose,
    onSelect,
    currentState,
  },
});

export const closeReorderConfirmationModalAction = () => ({
  type: CLOSE_REORDER_CONFIRMATION_MODAL,
});
